import React from "react";
import {checkPermission} from "../../../_helpers/commonFunctions";
import Alert from "react-bootstrap/Alert";
import {Button} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {addTabIfNotExists, generateTabKey} from "../../../_helpers/tabOpeners";
import {
    setHookTransactionModalData,
    setShowHookTransactionModal
} from "../../../_reducers/DataPanel/Accounting/accountingSlice";

export const ShowBankTransaction = ({document}) => {
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;
    const aiSettings = useSelector((state) => state.AI.aiSettings);

    const handleShowBankTransaction = () => {
        if (String(document?.bankTransaction).length === 24) {
            axios.get(process.env.REACT_APP_API_URL2 + "/accounting/transaction", {
                params: {company: company.id, transactionId: document?.bankTransaction},
                headers: { "Content-Type": "application/json" },
            }).then((res) => {
                if (res.data.status === "200") {
                    if (aiSettings?.enableBankingAI === true) {
                        dispatch(addTabIfNotExists("accounting-ai-banking-transactions", generateTabKey(), TABS_DATA));
                    } else {
                        dispatch(addTabIfNotExists("accounting-banking-transactions", generateTabKey(), TABS_DATA));
                    }
                    dispatch(setShowHookTransactionModal(true));
                    dispatch(setHookTransactionModalData({
                        transaction: res.data.data,
                        section: res.data.data.documentHooks[0]?.section,
                        documentHooks: res.data.data?.documentHooks || [],
                    }));

                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση άρθρου.")
        }
    }

    return (
        <React.Fragment>
            {(checkPermission("cash-banking/bankingtransactions-read", permissionsData) === true && String(document?.bankTransaction).length === 24) && (
                <Alert variant={"secondary"} className={"mb-1"}>
                    Το παρόν έγγραφο είναι συσχετιζόμενο με τραπεζική συναλλαγή.
                    <Button size={"sm"} onClick={() => handleShowBankTransaction()} style={{position: "absolute", right: "5px", top: "5px"}}>Προβολή τραπεζικής συναλλαγής</Button>
                </Alert>
            )}
        </React.Fragment>
    )
}